<section class="container">
  <div class="flex flex-row justify-between items-start mb-1">
    <rfc-heading-widget [headingName]="defineTitleAndDescriptionWidgetObj('change_mail')"></rfc-heading-widget>
    <mat-icon class="pointer" (click)="close()">close</mat-icon>
  </div>

  <form [formGroup]="changeMailForm">
    <div class="flex xs:flex-row justify-between gap-[2em] mt-1 mb-1">
      <mat-form-field class="full-width">
        <input matInput placeholder="{{ translate('oldEmail') }}" formControlName="oldEmail" />
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput placeholder="{{ translate('newEmail') }}" formControlName="newEmail" />
        <mat-error *ngIf="control(this.changeMailForm, 'newEmail').hasError">
          {{ getErrorMessage("newEmail") }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="flex flex-col xs:flex-row justify-center items-center gap-[2em] mt-2 mb-1">
      <button mat-flat-button (click)="submit()" class="ald-mat-button primary" [disabled]="
          !control(this.changeMailForm, 'newEmail').valid ||
          control(this.changeMailForm, 'newEmail').value.length === 0
        ">
        {{ "confirm_send" | i18n | uppercase }}
      </button>
    </div>
  </form>
</section>